import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { api, formatUSD } from "../lib/api";
import { UsersThree, CreditCard } from "@phosphor-icons/react";

export default function ManagerPanel() {
  const [users, setUsers] = useState([]);
  const [report, setReport] = useState(null);
  useEffect(() => {
    (async () => {
      const [u, r] = await Promise.all([api.get("/admin/users"), api.get("/reports/accounts")]);
      setUsers(u.data); setReport(r.data);
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#FBF9F6]">
      <Header />
      <div className="max-w-7xl mx-auto px-6 py-12">
        <p className="text-xs tracking-[0.3em] uppercase text-[#4A5C50]">Manager</p>
        <h1 className="serif text-5xl mt-2">Assigned customers</h1>

        <div className="grid md:grid-cols-3 gap-6 mt-10">
          <Stat icon={<UsersThree size={22} weight="duotone" />} label="Your customers" value={users.filter(u => u.role === "customer").length} />
          <Stat icon={<CreditCard size={22} weight="duotone" />} label="Active cards" value={report?.total_cards_active ?? "—"} />
          <Stat icon={<CreditCard size={22} weight="duotone" />} label="Principal" value={report ? formatUSD(report.total_principal_vnd) : "—"} />
        </div>

        <div className="bg-white border border-[#E5E0D8] rounded-2xl mt-10 overflow-hidden" data-testid="manager-users-table">
          <table className="w-full text-sm">
            <thead className="text-left text-[#4A5C50] text-xs uppercase tracking-widest">
              <tr><th className="p-4">Name</th><th className="p-4">Email</th><th className="p-4">Role</th><th className="p-4">Joined</th></tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id} className="border-t border-[#E5E0D8]">
                  <td className="p-4">{u.full_name}</td>
                  <td className="p-4 mono text-xs">{u.email}</td>
                  <td className="p-4">{u.role}</td>
                  <td className="p-4 text-xs text-[#4A5C50]">{new Date(u.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
const Stat = ({ icon, label, value }) => (
  <div className="bg-white border border-[#E5E0D8] rounded-2xl p-6 card-lift">
    <div className="text-[#184A30]">{icon}</div>
    <p className="text-xs tracking-[0.2em] uppercase text-[#4A5C50] mt-4">{label}</p>
    <p className="serif text-4xl mt-1">{value}</p>
  </div>
);
